/* eslint-disable max-lines-per-function */
import React, { useState } from "react";

import { get, trim } from "lodash";
import { Input } from "components/haven-design/form/inputs";
import { Modal } from "components/haven-design";
import { Button } from "components/haven-design/buttons";
import StructuredReasons from "components/structured-reasons";
import { STATUSES_REASON_LABEL } from "model/interest/status";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";

const ChangeStatusModal: React.FC<any> = ({
  selectedStatus,
  setSelectedStatus,
  onStatusChange,
  loading,
}) => {

  const [reason, setReason] = useState<null | string>(null);
  return (
    <Modal
      title={
        selectedStatus &&
    get(STATUSES_REASON_LABEL, selectedStatus, "Please provide a reason for this change.")
      }
      isOpen={selectedStatus !== null && selectedStatus !== "Moved In"}
      onRequestClose={() => setSelectedStatus(null)}
      fullWidth
    >
      <DialogContent>
        {selectedStatus === "Removed" ? (
          <StructuredReasons
            label="Removal Reason*"
            onChange={setReason}
          />
        ) : (
          <>
            <p>
            Changing the status to <strong>{selectedStatus}</strong> requires a reason for
            auditing purposes.
            </p>
            <Input
              type="text"
              name="Reason"
              label="Reason"
              placeholder="Enter a reason..."
              value={reason || ""}
              onChange={(event) => setReason(event.target.value)}
            />
          </>
        )}

      </DialogContent>


      <DialogActions>
        <Button color="secondary" size="S" onClick={() => {
          setReason(null);
          setSelectedStatus(null);
        }}>
        Cancel
        </Button>
        <Button
          disabled={trim(reason || "") === "" || loading}
          color="primary"
          size="S"
          onClick={() => {
            if (selectedStatus === null) {
              return;
            }

            onStatusChange(selectedStatus, reason);
          }}
        >
        Confirm
        </Button>
      </DialogActions>
    </Modal>);
};

export default ChangeStatusModal;
